import { render, staticRenderFns } from "./Notificaciondeprivacidad.vue?vue&type=template&id=71e1afee&scoped=true&"
import script from "./Notificaciondeprivacidad.vue?vue&type=script&lang=js&"
export * from "./Notificaciondeprivacidad.vue?vue&type=script&lang=js&"
import style0 from "./Notificaciondeprivacidad.vue?vue&type=style&index=0&id=71e1afee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1afee",
  null
  
)

export default component.exports